import { ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Observable } from 'rxjs';
import { Overlay } from "@angular/cdk/overlay";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ControlUser } from '../model/controlUser';
import { DevicePilomat } from '../model/devicePilomat';
import { LogEvent } from '../model/logEvent';
import { DeviceService } from '../service/device.service';
import { Log } from '../util/log';

@Component({
  selector: 'app-link-owner-device-dialog',
  templateUrl: './link-owner-device-dialog.component.html',
  styleUrls: ['./link-owner-device-dialog.component.css']
})
export class LinkOwnerDeviceDialogComponent implements OnInit {

  @ViewChild('linkownerdeviceloader', { static: true }) loader;
  @ViewChild('linkownerdevicetable', { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<DevicePilomat>();
  selectedDevice: DevicePilomat;
  selectedRow: number;

  dataSource: MatTableDataSource<DevicePilomat>;

  displayedColumns: string[] = ['name', 'serial', 'version', 'city', 'address'];

  owner: ControlUser;
  deviceList: DevicePilomat[];

  constructor(
    public dialogRef: MatDialogRef<LinkOwnerDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private overlay: Overlay) {

    this.owner = data.owner;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getDeviceList();
    });
  }

  getDeviceList() {

    Log.debug("getDeviceList");

    this.loader.showLoading();

    const obs = this.deviceService.getUnlinkedDevices();
    obs.subscribe(data => {

      this.deviceList = data;

      this.table.dataSource = new MatTableDataSource(this.deviceList);
      this.table.dataSource.sort = this.sort;
      this.table.dataSource.filterPredicate = this.filterTable;

      this.loader.hideLoading();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }


  onRowClicked(row) {

    let message = $localize`:@@linkownerdevice_link_device_confirm1:Desideri associare il dispositivo` + " " + row.serial + $localize`:@@linkownerdevice_link_device_confirm2:  al gestore` + " " + this.owner.displayName + " ?";
    let confirmMessage = $localize`:@@linkownerdevice_link_device_confirm_yes: Conferma`;
    let cancelMessage = $localize`:@@linkownerdevice_link_device_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        Log.debug('clicked device ' + JSON.stringify(row));

        this.selectedRow = row.id;

        this.selected.emit(row);
        this.selectedDevice = row;

        this.cdRef.detectChanges();

        this.dialogRef.close({ device: row });
      }
    });


  }

  onKey(event: any) {

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: DevicePilomat, filter: string): boolean {

    if (data.systemInfo.reference && data.systemInfo.reference.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.systemInfo.address && data.systemInfo.address.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.systemInfo.city && data.systemInfo.city.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }


  closeDialog() {

    this.dialogRef.close();
  }
}

export class DevicesSource extends MatTableDataSource<DevicePilomat> {

  deviceSerial: number;
  isLoading = new BehaviorSubject(false);
  devicesData = new BehaviorSubject<DevicePilomat[]>([]);

  constructor(private deviceService: DeviceService) {
    super();

    // this.filterPredicate = function (data: DevicePilomat, filter: string): boolean {
    //   Log.debug("filter: " + filter);
    //   return false;
    // }
  }

  loadData() {
    this.isLoading.next(true);

    const obs = this.deviceService.getUnlinkedDevices();
    obs.subscribe(data => {
      this.isLoading.next(false);
      this.devicesData.next(data);
    });
  }

  connect(): BehaviorSubject<DevicePilomat[]> {
    this.loadData();
    return this.devicesData;
  }

  disconnect() {
  }
}
